/**
 * Direction of one field.
 *
 * A typed Latin value (secret, URL, key, SKU) stays left to right.
 * Other typed text keeps its own direction.
 * An empty field follows the placeholder: Hebrew prompt text sits on the
 * right in a right-to-left page, and a Latin prompt stays on the left.
 * With no placeholder, an empty field follows the page.
 */
export function fieldDir(
  value: string,
  placeholder = '',
  latinValue = false,
): 'ltr' | 'rtl' | 'auto' | undefined {
  if (value.trim()) return latinValue ? 'ltr' : 'auto';
  if (startsWithRtlLetter(placeholder)) return 'rtl';
  if (placeholder) return 'ltr';
  return undefined;
}

function startsWithRtlLetter(text: string): boolean {
  for (const ch of text.trim()) {
    const code = ch.codePointAt(0) ?? 0;
    if (code >= 0x0590 && code <= 0x08ff) return true;
    if ((code >= 0x41 && code <= 0x5a) || (code >= 0x61 && code <= 0x7a)) return false;
  }
  return false;
}
